
export const roles = {
  label: "Roles",
  type: "array",
  items: {
    type: "string",
    default: "",
  },
  default: [],
  widget: "tags",
};

export const keyId = {
  label: "API Key ID",
  type: "string",
};

// What the key is for, in the owner's words. The only thing that tells two
// keys apart once created: keyId is opaque and the secret is shown once.
// Optional, because every caller that predates it — the seed script and both
// app forms — creates a key without one.
export const description = {
  label: "Description",
  type: "string",
};

// The stored column. Nullable, because datorm's serialize() turns an absent
// string into null, and a bare {type:"string"} would then fail validation at
// create for every key made without a description — which is every key that
// predates the field, and every one auth's own forms still make. The input
// shape above stays non-nullable: a form does not offer a null.
export const descriptionData = {
  ...description,
  type: ["string", "null"],
};

export const ownerId = {
  label: "Owner Id",
  type: "string",
};

export const keySecret = {
  type: "string",
};


export const ownerOrgId = {
  type: "string",
};


export const resourceType = {
  type: "string",
};


// The one resource of the owning organization a key is bound to, as three
// names the caller supplies — `service`, `type` and `id` — for a key minted for
// a third-party agent. docs/scoped-keys.md. The owner stays the
// ORGANIZATION — ownerId, resourceType and ownerOrgId are unchanged — so the
// key lists, counts and revokes exactly like any other; this narrows what it
// reaches inside that organization and never replaces the tenant. A key
// carrying one holds exactly `roles: ["agent"]`, and auth-repoflow refuses it
// to every keys.check caller that does not name its kind in `acceptScopes`.
//
// The resource is the owning service's row, so this service only stores the
// names and checks their shape — `service` and `type` lowercase slugs, `id`
// any non-empty text. Getting them right is the minting user's responsibility;
// that the resource exists and is the organization's is checked by the service
// the key is presented to, on every request, by the organization scoping its
// reads carry.
export const scope = {
  label: "Scope",
  type: "object",
  properties: {
    service: { label: "Service", type: "string" },
    type: { label: "Type", type: "string" },
    id: { label: "Id", type: "string" },
  },
};

// Stored column: `<service>:<type>:<id>` (data/key-scope), null on every key
// that is not bound — datorm serializes an absent string to null.
export const scopeData = {
  label: "Scope",
  type: ["string", "null"],
};

// A scoped key's own rate limits, per window, overriding the defaults in
// api/code/src/data/key-rate (60 a minute, 5,000 a day) — docs/scoped-keys.md
// §The rate limit. Null on every row today: nothing writes it but a hand edit,
// and a window it does not name, or names with anything but a positive
// integer, keeps its default. Meaningless on an organization-wide key, which
// is never counted. `rateLimit` is what `Key.rateLimit` reads back — the
// limits in force, defaults filled in — and what the app's key views show.
export const rateLimit = {
  label: "Rate limit",
  type: "object",
  properties: {
    minute: { label: "Per minute", type: "integer" },
    day: { label: "Per day", type: "integer" },
  },
};

export const rateLimitData = {
  ...rateLimit,
  type: ["object", "null"],
};
